import { useTranslation } from 'react-i18next'

import { PencilIcon } from '#/shared/ui/icons'
import { Skeleton } from '#/shared/ui/skeleton'

export function PaymentCardSkeleton() {
  const { t } = useTranslation()
  return (
    <div className="flex w-full flex-col gap-2.5 rounded-md border border-gray-200 bg-white pt-2.5 pb-5">
      <div className="flex flex-col gap-1.25">
        <div className="flex h-8 items-center justify-between gap-2.5 px-5 pb-1.25">
          <h3 className="text-base font-semibold text-gray-900">
            {t('orderDetails.payment.title')}
          </h3>
          <button
            type="button"
            disabled
            aria-hidden
            className="flex size-8 items-center justify-center rounded-md border border-gray-200 bg-white text-gray-500 opacity-60"
          >
            <PencilIcon className="size-3.5" />
          </button>
        </div>
        <div className="h-px w-full bg-gray-200" />
      </div>
      <div className="flex flex-col gap-1.25">
        <div className="flex h-8 items-center justify-between px-5">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
        <div className="flex h-8 items-center justify-between px-5">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-4 w-16" />
        </div>
        <div className="flex h-8 items-center justify-between px-5">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-4 w-20" />
        </div>
      </div>
    </div>
  )
}
